/* eslint-disable max-lines-per-function */
import { handleDelete } from '@/domain/mitarbeiter/features/rotationsplan/features/DeleteRotationsplan/handleDelete';
import { useDeleteRotationsplan } from '@/domain/mitarbeiter/features/rotationsplan/hooks/useDeleteRotationsplan/useDeleteRotationsplan';
import { useStandortContext } from '@/features/standortContext/StandortContext';
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  DropdownMenuItem,
} from '@e2n/ui';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

export function DeleteRotationsplanDesktop({
  rotationsplanId,
  onClose,
}: {
  rotationsplanId: string;
  onClose: () => void;
}) {
  const { t } = useTranslation();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { standorte } = useStandortContext();
  const standortIds = standorte.map((s) => s.id);
  const [deleteRotationsplan] = useDeleteRotationsplan(standortIds);
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);

  function handleConfirm() {
    handleDelete({
      deleteRotationsplan,
      navigate,
      rotationsplanId,
      t,
      setIsSubmitting,
    });
  }

  return (
    <>
      <Dialog open={isOpen} onOpenChange={setIsOpen}>
        <DialogContent className="hidden md:max-w-111 p-8 md:flex flex-col gap-6">
          <DialogTitle>
            {t(
              'domain.mitarbeiter.rotationsplan.rotationsplaene.deleteRotationsplan.dialogTitle',
            )}
          </DialogTitle>
          <div className="flex flex-col gap-2 text-sm">
            <div className="text-neutrals-900">
              {t(
                'domain.mitarbeiter.rotationsplan.rotationsplaene.deleteRotationsplan.dialogText',
              )}
            </div>
            <div className="text-primary-red-600">
              {t(
                'domain.mitarbeiter.rotationsplan.rotationsplaene.deleteRotationsplan.infoStandortwechsel',
              )}
            </div>
          </div>
          <div className="flex items-center justify-end gap-4">
            <Button
              disabled={isSubmitting}
              variant="destructive"
              onClick={handleConfirm}>
              {t(
                'domain.mitarbeiter.rotationsplan.rotationsplaene.deleteRotationsplan.confirm',
              )}
            </Button>
            <Button
              onClick={() => {
                setIsOpen(false);
                onClose();
              }}
              variant="outline">
              {t(
                'domain.mitarbeiter.rotationsplan.rotationsplaene.deleteRotationsplan.dismiss',
              )}
            </Button>
          </div>
        </DialogContent>
      </Dialog>
      <DropdownMenuItem
        onClick={(e) => {
          e.preventDefault();
          setIsOpen(true);
        }}>
        {t(
          'domain.mitarbeiter.rotationsplan.rotationsplaene.deleteRotationsplan.label',
        )}
      </DropdownMenuItem>
    </>
  );
}
